import axios, { AxiosError, AxiosInstance } from 'axios';

type ApiClientOptions = {
  baseURL: string;
};

export type ApiErrorData = {
  message?: string;
  [key: string]: unknown;
};

export const createApiClient = (options: ApiClientOptions): AxiosInstance => {
  const client = axios.create({
    baseURL: options.baseURL,
    headers: {
      Accept: 'application/json',
    },
  });

  return client;
};

export const isAxiosError = <T = ApiErrorData>(
  e: unknown,
): e is AxiosError<T> => {
  return axios.isAxiosError(e);
};

export const getErrors = (e?: string[]): string => {
  return e ? e.join(', ') : '';
};
